import React from 'react';
import ProductCard from './ProductCard';
import ProductListItem from './ProductListItem';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';



const ProductGrid = ({ 
  products, 
  viewMode, 
  onAddToCart, 
  onToggleWishlist, 
  isLoading 
}) => {
  if (isLoading) {
    return (
      <div className={`grid gap-6 ${
        viewMode === 'grid' ?'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4' :'grid-cols-1'
      }`}>
        {Array.from({ length: 12 })?.map((_, index) => (
          <div key={index} className="animate-pulse">
            <div className="bg-muted rounded-xl aspect-square mb-4"></div>
            <div className="space-y-2">
              <div className="h-4 bg-muted rounded w-3/4"></div>
              <div className="h-4 bg-muted rounded w-1/2"></div>
              <div className="h-6 bg-muted rounded w-1/3"></div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (products?.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-4">
          <Icon name="Search" size={32} className="text-muted-foreground" />
        </div>
        <h3 className="text-lg font-heading font-medium text-foreground mb-2">
          No products found
        </h3>
        <p className="text-muted-foreground mb-6 max-w-md">
          We couldn't find any products matching your criteria. Try adjusting your filters or search terms.
        </p>
        <Button variant="outline">
          Clear All Filters
        </Button>
      </div>
    );
  }

  return (
    <div className={`grid gap-6 ${
      viewMode === 'grid' ?'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4' :'grid-cols-1'
    }`}>
      {products?.map((product) => (
        viewMode === 'grid' ? (
          <ProductCard
            key={product?.id}
            product={product}
            onAddToCart={onAddToCart}
            onToggleWishlist={onToggleWishlist}
          />
        ) : (
          <ProductListItem
            key={product?.id}
            product={product}
            onAddToCart={onAddToCart}
            onToggleWishlist={onToggleWishlist}
          />
        )
      ))}
    </div>
  );
};

export default ProductGrid;